<template>
  <div class="mainComp">
    <sidebar_user :setorders="orders" />
    <!-- <modal-event-vue/> -->

    <section class="home-section">
      <!-- <div class="text">Dashboard</div> -->
      <br />
      <b-container fluid>
        <slider />
        <br />
        <br />
        <br />
    <!-- <pumpkinLine/> -->
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-xs-0"></div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-xs-12">
            <form action="" @submit.prevent="searchbook">
              <div class="search">
                <input
                  id="myInput"
                  type="text"
                  class="search__input"
                  placeholder="Search.."
                  style="border-radius: 30px"
                  pull-right
                  v-model="search"
                />

                <div class="search__icon">
                  <i class="fa-solid fa-search"></i>
                  <!-- <ion-icon name="search"></ion-icon> -->
                </div>
              </div>
            </form>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-xs-0"></div>
        </div>
        <br />
        <br />
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <h6 class="display-4 service-txt">บริการของเรา</h6>
            <br />
          </div>
        </div>
        <b-container>
          <div class="row text-center">
            <!-- End -->
            <!-- Team item -->
            <div class="col-xl-6 col-sm-6 mb-5">
              <router-link to="/booking">
                <div class="py-3 px-4 card-service">
                  <img
                    src="../../assets/icons/reserved.png"
                    alt=""
                    width="100"
                    class="img-fluid mb-3"
                  />
                  <h5 class="mb-0 txt-service">จองหนังสือ</h5>
                  <span class="small text-uppercase text-muted txt-service"
                    >Booking</span
                  >
                </div>
              </router-link>
            </div>
            <!-- End -->

            <div class="col-xl-6 col-sm-6 mb-5">
              <router-link to="/BookingRoom">
                <div class="py-3 px-4 card-service">
                  <img
                    src="../../assets/icons/round-table.png"
                    alt=""
                    width="100"
                    class="img-fluid mb-3"
                  />
                  <h5 class="mb-0 txt-service">จองห้อง</h5>
                  <span class="small text-uppercase text-muted txt-service"
                    >Booking Room</span
                  >
                </div>
              </router-link>
            </div>

            <!-- <router-link to="/login" v-if="!chk_auth" >
                <div class="bg-gray rounded shadow-sm py-3 px-4">
                  <img
                    src="../assets/icons/round-table.png"
                    alt=""
                    width="100"
                    class="img-fluid mb-3"
                  />
                  <h5 class="mb-0 txt-service">จองห้องกลุ่มย่อย</h5>
                  <span class="small text-uppercase text-muted">Meeting Room</span>
                </div>
              </router-link>
               -->

            <!-- End -->
            <!-- Team item -->
            <div class="col-xl-4 col-sm-6 mb-5">
              <!-- <router-link to="/ubrucoffee">
                <div class="py-3 px-4 card-service">
                  <img
                    src="../../assets/icons/borrow.png"
                    alt=""
                    width="100"
                    class="img-fluid mb-3"
                  />
                  <h5 class="mb-0 txt-service">ยืม & คืน</h5>
                  <span class="small text-uppercase text-muted txt-service"
                    >@UBRU Coffee</span
                  >
                </div>
         
              </router-link> -->
              <!-- <router-link to="/newbook"> -->
              <!-- <a
                href="https://libestream.ubru.ac.th/libestream/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div class="py-3 px-4 card-service">
                  <img
                    src="../../assets/icons/borrow.png"
                    alt=""
                    width="100"
                    class="img-fluid mb-3"
                  />
                  <h5 class="mb-0 txt-service">ยืม & คืน</h5>
                  <span class="small text-uppercase text-muted txt-service"
                    >@UBRU Coffee</span
                  >
                </div>
              </a> -->
              <!-- </router-link> -->
            </div>
            <!-- End -->
          </div>
        </b-container>
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import slider from "@/views/layouts/slider";
// import $ from "jquery";
import axios from "axios";
import CryptoJS from "crypto-js";
// import modalEventVue from '../../views/events/modalEvent.vue';
// Event
// import pumpkinSpider from "../../views/events/halloween/pumpkinSpider.vue";
// import pumpkinLine from "../../views/events/halloween/pumpkinLine.vue";
export default {
  name: "mainComp",
  components: { sidebar_user, slider  },
  data() {
    return {
      disble: false,
      disabled: false,
      search: "",
      showCart: false,
      verified: false,
      secret_one: "",
      keycomponent: "",
      datas: "",
      filteredArr: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      loggedIn: false,
      orders: [],
      status_login: false,
      status_: false,
      staff: false,
      s: 0,
      code: "",
      isLoading: false,
      chk_qty: [],
      chk_auth: false,
      setorders: [],
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted() {
    
    this.getIPAddress();
    this.status();
//     $(document).ready(function() {
//   //Use jQuery to show the popup
//   $('.modalDialog').show();
//   //Alternativly use jQuery to fadeIn the popup
//   $('.modalDialog').fadeIn()
// });


    if (localStorage.getItem("auth") != null) {
      this.getorder();
      this.chk_auth = true;
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
      console.log(this.code,'std_code');
      this.orders = JSON.parse(localStorage.getItem("orders"));
      console.log(this.orders,'setOrders');
      if (c.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    }

    if (localStorage.getItem("booking") != null) {
      this.filteredArr = JSON.parse(localStorage.getItem("booking"));
      this.s = this.filteredArr.length;
    } else {
      this.s = 0;
    }
    if (localStorage.getItem("orders") != null ) {
      this.loadOrder();
    }
    if (
      localStorage.getItem("access_token") == "" ||
      localStorage.getItem("access_token") == null
    ) {
      this.disble = false;
    } else {
      this.disble = true;
    }
  },
  methods: {
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    getorder() {
      let c = JSON.parse(localStorage.getItem("auth"));
      
      let data = {
        token: this.token,
        std_code: c.std_code,
      };
      console.log(data,'data');

      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          console.log("order welcome", res);
          if (res.data.Orders !== null) {
            this.orders = res.data.Orders;
            for (var i in this.orders) {
              if (this.orders[i].order_status === 5) {
                this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
              }
            }
            console.log(this.orders, "get order");
            localStorage.setItem("orders", JSON.stringify(this.orders));
          }
        });
    },
    getIP() {
      // this.getIPAddress().then(res => {
       
      // });
    },
    getIPAddress() {
      axios
        .get("https://api.ipify.org/?format=json")
        .then((res) => {
          this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
        // console.log(this.ipAddress);
        })
        .catch(console.log(""));
    },
    status() {
      if (!localStorage.getItem("access_token")) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
    searchbook() {
      console.log("search book");
      let ip = localStorage.getItem("IP");

      let std;
      let curdate = new Date();
      curdate.setUTCHours(curdate.getUTCHours() + 7);
      let timespit = curdate.toISOString().slice(0, 13).split("T");
      let objDate = {
        date: timespit[0],
        time: timespit[1],
      };
      std = {
        token:
          "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
        keyword: this.search,
        public_ip: ip,
      };
      this.keycomponent =
        "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
      this.secret_one = this.keycomponent + objDate.date + " " + objDate.time;
      this.datas = {
        ciphertext: "",
        token: this.token_key,
      };

      // let ciphertext = this.encrypt_data(JSON.stringify(std), this.secret_one);
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/search", std, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);
            this.datas = res.data.books;
            // console.log(this.datas);
            localStorage.setItem("datas", JSON.stringify(this.datas));
            this.$router.push("/booking");
          }
          // let api_data = res.data[0].data;
          // let decypt_once_data_req = this.decrypt_once(
          //   api_data,
          //   this.secret_one
          // );
          // let parse_json_decypt_once_data_req = JSON.parse(
          //   decypt_once_data_req
          // );

          // let decrypt_two_parse_json_decypt_once_data_req = this.decrypt_once(
          //   parse_json_decypt_once_data_req.ciphertext,
          //   this.secret_one
          // );
          // let parse_json_decypt_two = JSON.parse(
          //   decrypt_two_parse_json_decypt_once_data_req
          // );
          // localStorage.setItem(
          //   "data-search",
          //   JSON.stringify(parse_json_decypt_two.books)
          // );
        });
    },
    encrypt_data(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(this.secret_one).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      this.datas.ciphertext = CryptoJS.AES.encrypt(plaintext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      passphrase = "";
      return {
        data: this.encrypt_once(JSON.stringify(this.datas), secret).toString(),
      };
    },

    encrypt_once(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let ciptext = CryptoJS.AES.encrypt(JSON.stringify(plaintext), key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      return ciptext;
    },

    decrypt_once(ciphertext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let bytes = CryptoJS.AES.decrypt(ciphertext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      });
      let decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    },
  },
};
</script>

<style lang="scss" scoped>
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}
/*Card Service*/
.card-service {
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
  background: none;
  font-family: inherit;
  color: orangered;
  font-weight: bold;
}
.txt-service {
  font-weight: bold;
  
}
/*End */
/*SEARCH */

.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: var(--greyDark);
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
.card-body-menu {
  margin-top: 70px;
  font-family: "Kanit", sans-serif;
}
.card-title {
  text-align: center;
  font-family: "Kanit", sans-serif;
}
::placeholder {
  color: rgb(255, 255, 255);
}
.card-search {
  top: 20px;
  border: 0px solid;
  font-family: "Kanit", sans-serif;
}
/* END SEARCH*/
@media screen and (max-width: 375px) {
}
@media screen and (max-width: 991px) {
}
@media screen and (max-width: 1200px) {
}
a:hover{
  text-decoration: none;
}
h5{
  color: #11101d;
}
/* halloween */
.modalDialog {
  //added display none on element
  display:none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  //opacity: 0;
  -webkit-transition: opacity 400ms ease-in;
  -moz-transition: opacity 400ms ease-in;
  transition: opacity 400ms ease-in;
  pointer-events: none;
}
</style>
